import { qs, qsa } from '../utils'
import bidello from '../bidello'
import gsap, { Power4 } from 'gsap'
import menu from '../menu'
import scroll from '../animations/scroll/locomotiveScroll'

export const archiveTimeTransition = {
  name: 'archive-time',

  to: {
    namespace: 'archive-time',
  },

  once({ next }) {
    const tl = animation(next.container)

    bidello.on('loaderEnd', () => {
      tl.play()
    })
  },

  enter({ next, current }) {
    current.container.style.display = 'none'

    const tl = animation(next.container)

    return tl.play()
  },

  leave({ next, current }) {
    if (menu.isOpen) {
      menu.menuLeave()
    }

    gsap.set(next.container, { autoAlpha: 0 })

    return gsap.to(current.container, {
      opacity: 0,
      duration: 1.2,
      onComplete: () => {
        scroll.scrollTo({ target: 0, options: { duration: 0, disableLerp: true } })
      }
    })
  }
}

const animation = (container) => {
  const isMobile = window.innerWidth < 768

  const slideshow = qs('.x-plore__slider', container)
  const title = qs('h1', container)
  const desc = qs('.time-intro p', container)
  const images = qsa('.decorations img', container)

  const tl = gsap.timeline({ paused: true })

  tl
    .set(container, { autoAlpha: 1 })
    .call(() => {
      const elements = isMobile ? [] : images.slice(0, 5)
      elements.forEach(el => {
        el.setAttribute('animate', '')
        el.style.animationDelay = `${Math.random()}s`
      })
    })
    .from(slideshow, {
      duration: 1.6,
      autoAlpha: 0,
      ease: Power4.easeOut
    }, 0)
    .from(title, {
      duration: 1.6,
      yPercent: 100,
      ease: Power4.easeOut
    }, 0)
    .add('other')
    .from(desc, {
      duration: 1.6,
      autoAlpha: 0,
      ease: Power4.easeOut
    }, 'other-=0.8')

  return tl
}
